import styled from 'styled-components';
import { breakpoints } from "../../commons/breakpoints";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
  display: block;
  margin: 32px 0 16px;
  padding: 18px 16px 16px;
  color: ${props => props.theme.colors.black};
  font-size: 11px;
  line-height: 11px;
  font-family: 'ReadMedium';
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, .75);
  border: 2px solid ${props => props.theme.colors.black};
  vertical-align: middle;
  
  @media ${breakpoints.sm} {
    font-size: 14px;
    line-height: 14px;
  }
`;

const LinkButton = ({text, destination}) => {
  return (
      <StyledLink to={destination} className="link-button">{text}</StyledLink>
  );
};

LinkButton.propTypes = {
  text: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired
};

export default LinkButton;
